<template>
  <div>
    <a-row type="flex" class="area-header">
      <h1 class="title">Datasources</h1>
      <a-button type="primary" @click="$router.push('/admin/datasources/new')">Create new</a-button>
    </a-row>

    <a-table :columns="columns" :dataSource="datasourcesArray" :rowKey="record => record.id">
      <div class="_d-flex" slot="action" slot-scope="record">
        <a-button size="small" @click="showItems(record)">Items</a-button>
        <a-button size="small" @click="handleEdit(record)">Edit</a-button>
        <a-button size="small" type="danger" @click="handleDelete(record.id)">Delete</a-button>
      </div>
    </a-table>
  </div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  name: "Datasources",
  data() {
    return {
      columns: [
        {
          title: "Name",
          dataIndex: "name",
          key: "name"
        },
        {
          title: "Action",
          key: "action",
          scopedSlots: { customRender: "action" }
        }
      ]
    };
  },
  methods: {
    handleEdit(datasource) {
      this.$router.push(`/admin/datasources/${datasource.id}`);
    },
    handleDelete(datasourceId) {
      this.$store.dispatch("datasource/delete", datasourceId);
    },

    showItems(datasource) {
      this.$router.push(`/admin/datasources/${datasource.id}/items`);
    }
  },
  async created() {
    this.$store.commit("SET_IS_FETCHING", true);
    await this.$store.dispatch("datasource/fetchAll");
    this.$store.commit("SET_IS_FETCHING", false);
  },
  computed: {
    ...mapGetters("datasource", {
      datasourcesArray: "asArray"
    })
  }
};
</script>
